module.exports = __webpack_public_path__ + "img/pms.94650e86.png";